export default __webpack_public_path__ + "static/media/LK.1b79e760.svg";